import { GlobalWorkerOptions } from 'pdfjs-dist';

/** Use the bundled worker for both document previews and local SDS scanning. */
export function configurePdfWorker(): void {
  const workerSrc = new URL('assets/pdf.worker.min.mjs', document.baseURI).href;
  GlobalWorkerOptions.workerSrc = workerSrc;
  // ng2-pdf-viewer reads this setting when constructing its PDF.js viewer.
  Reflect.set(window, 'pdfWorkerSrc', workerSrc);
}
